"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attractionEffect = void 0;
var common_1 = require("@timeflies/common");
/**
 * Attract target to 3 tiles. Change its orientation toward launcher.
 */
exports.attractionEffect = {
    effect: function (_a) {
        var getHitCharactersAlive = _a.getHitCharactersAlive, targetPos = _a.targetPos, getLauncher = _a.getLauncher, isPositionAccessible = _a.isPositionAccessible;
        return __awaiter(void 0, void 0, void 0, function () {
            var launcher, targets, characters, orientation;
            return __generator(this, function (_b) {
                launcher = getLauncher();
                targets = getHitCharactersAlive();
                characters = targets.reduce(function (acc, target) {
                    var _a;
                    var orientFromTarget = common_1.getOrientationFromTo(target.position, launcher.position);
                    acc[target.characterId] = {
                        orientation: orientFromTarget
                    };
                    var getNextPosition = common_1.switchUtil(orientFromTarget, {
                        bottom: function (_a) {
                            var x = _a.x, y = _a.y;
                            return common_1.createPosition(x, y + 1);
                        },
                        top: function (_a) {
                            var x = _a.x, y = _a.y;
                            return common_1.createPosition(x, y - 1);
                        },
                        left: function (_a) {
                            var x = _a.x, y = _a.y;
                            return common_1.createPosition(x - 1, y);
                        },
                        right: function (_a) {
                            var x = _a.x, y = _a.y;
                            return common_1.createPosition(x + 1, y);
                        },
                    });
                    for (var i = 0; i < 3; i++) {
                        var nextPosition = getNextPosition((_a = acc[target.characterId].position) !== null && _a !== void 0 ? _a : target.position);
                        if (!isPositionAccessible(nextPosition)) {
                            break;
                        }
                        acc[target.characterId].position = nextPosition;
                    }
                    return acc;
                }, {});
                orientation = common_1.getOrientationFromTo(launcher.position, targetPos);
                characters[launcher.characterId] = __assign(__assign({}, characters[launcher.characterId]), { orientation: orientation });
                return [2 /*return*/, {
                        characters: characters
                    }];
            });
        });
    }
};
